import { render, staticRenderFns } from "./BrickAndSubstructurePrintPage2.vue?vue&type=template&id=72e2d292"
import script from "./BrickAndSubstructurePrintPage2.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructurePrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports